import "../../src/user_registrations/new";